import { useState } from "react";
import Seo from "../../Components/SeoComponent/Seo";
import Header from "../../Components/Header";
import CreateMandateForm from "./CreateMandate";
import MandateTable from "./MandateTable";
import Loader from "../../Loader";

export default function MandateDashboard() {
  const [isLoading, setIsLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshMandates = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading="Mandate Dashboard" />

      <div className="bg-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto space-y-6">

          <CreateMandateForm
            onSuccess={refreshMandates}
            setGlobalLoading={setIsLoading}
          />

          <MandateTable
            refreshKey={refreshKey}
            onSuccess={refreshMandates}
            setGlobalLoading={setIsLoading}
          />


  
        </div>
      </div>
    </>
  );
}
